<template>
  <WsRead
    :modelName="modelName"
    :versionModelName="versionModelName"
    :submodelName="submodelName"
    :modelVersionName="`${modelName}_version`"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modeVersions="modeVersions"
    titleKey="last_version.name"
    :sortable="true"
    :customBtns="_customBtns"
    :isFetchData="isFetchData"
    :hasChapters="hasChapters"
    :versionCreatable="false"
    :createVersion="true"
    :itemVersionLinkCreatable="itemVersionLinkCreatable"
    :itemVersionCreatable="itemVersionCreatable"
    :itemVersionReadable="itemVersionReadable"
    :itemEditable="itemEditable"
    :itemDeletable="itemDeletable"
    :isPostVersion="_isPostVersion"
    :sequenceFields="_sequenceFields"
    @input="$_getModelData($event)"
    @versionPostable="$_onPostVersionAlert()"
    @createTemplateVersion="$_onCreateVersionAlert()"
  >
    <WsAlertDialog
      ref="postVersionAlertDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onPostVersion()"
    />
    <WsAlertDialog
      ref="createVersionAlertDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onCreateVersion()"
    />
  </WsRead>
</template>

<script>
import model from "@/models/audit_template";
import submodel from "@/models/audit_question_template";
import S_base from '@/services/wasaapi/__base';

export default {
  data: () => ({
    modelName: model.modelName,
    versionModelName: model.versionModelName,
    submodelName: submodel.modelName,
    submodelVersionName: submodel.modelVersionName,
    label: model.label,
    localeMode: true,
    modeVersions: true,
    hasChapters: true,
    fields: model.fields,
    isFetchData: false,
    modelVersionData: {},
    alertTitle: "",
    alertDescription: "",
    btnText: "",
    modelData: null,
    itemVersionLinkCreatable: false,
    itemVersionCreatable: false,
    itemVersionReadable: false,
    itemEditable: false,
    itemDeletable: false,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          hideOnNull: false,
          floors: [
            {
              fields: ["last_version.locales"],
              hideLabelFields: [],
            },
          ],
        },
        {
          type: "expandList",
          label: submodel.label,
          modelName: submodel.modelName,
          modeParent: true,
          modeParentVersions: true,
          fields: submodel.fields,
          titleKey: "last_version.title",
          fieldsRead: submodel.fieldsRead,
          searchMode: false,
          hideOnNull: false,
          isGetAll: true,
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類資訊",
              fields: [
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_admin", "created_at"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["last_version.updated_admin", "last_version.updated_at"],
            },
          ],
        },
        {
          type: "select",
          title: "顯示設定",
          remark: "隱藏的內容將不會顯示於使用者前台介面",
          field: "status",
        },
      ],
    },
  }),
  computed: {
    _customBtns() {
      return [
        {
          title: `複製`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-content-copy",
          emit: "createTemplateVersion",
          to: `/audit_template/${this.$route.params.id}/duplicate`,
          checkDisplayOnModelData: function(){return true},
        },
        {
          title: this._editTopicText,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-pencil",
          to: this._editTopicRouter,
        },
        {
          title: `更新版本`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          emit: "createTemplateVersion",
          checkDisplayOnModelData: (modelData) => {
            if (modelData.last_version.version_status) {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          title: "發布新版本",
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          emit: "versionPostable",
          checkDisplayOnModelData: (modelData) => {
            if (modelData.last_version.version_status) {
              return false;
            } else {
              return true;
            }
          },
        },
      ];
    },
    _editTopicText() {
      if (!this.modelData) return;
      if (this.modelData.last_version.version_status === 1) {
        return "編輯當前版本題目";
      } else {
        return "更新題目版本";
      }
    },
    _editTopicRouter() {
      if (!this.modelData) return;
      if (this.modelData.last_version.version_status === 1) {
        return `/${this.modelName}/${this.$route.params.id}/add_chapter/${this.modelData.last_version.id}`;
      } else {
        return `/${this.modelName}/${this.$route.params.id}/create_version/${this.modelData.last_version.id}`;
      }
    },
    _isPostVersion() {
      if (this.modelData) {
        if (this.modelData.last_version) {
          if (!this.modelData.last_version.version_status) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    _sequenceFields() {
      if (this.modelData) {
        return this.modelData.last_version.chapters;
      } else {
        return null;
      }
    },
  },
  methods: {
    async $_getModelVersionData(modelData) {
      try {
        let getUrl = `/${this.versionModelName}/${modelData.last_version.id}`;
        const res = await this.$axios.get(getUrl);
        this.modelVersionData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    $_onPostVersionAlert() {
      this.alertTitle = "發布新版本";
      this.alertDescription = "確定要發布新版本嗎？";
      this.btnText = "確認";
      this.$refs.postVersionAlertDialog.open();
    },
    async $_onPostVersion() {
      this.$refs.postVersionAlertDialog.startLoading();
      await this.$_getModelVersionData(this.modelData);
      try {
        let newArr = [];
        this.modelVersionData[`${this.submodelVersionName}s`].forEach(
          (item) => {
            newArr.push(
              this.$axios.patch(`/${this.submodelVersionName}/${item.id}`, {
                status: 1,
              })
            );
          }
        );
        if (newArr.length) {
          await Promise.all(newArr);
        }
        try {
          await this.$axios.patch(
            `/${this.versionModelName}/${this.modelVersionData.id}`,
            { version_status: 1 }
          );
        } catch (error) {
          alert(error);
        }
        await S_base.update({
          modelName: this.modelName,
          modelId: this.$route.params.id,
          payload: {status: 1},
        });
        this.$refs.postVersionAlertDialog.close();
        this.$refs.postVersionAlertDialog.stopLoading();
        this.isFetchData = !this.isFetchData;
      } catch (error) {
        alert(error);
      }
    },
    $_onCreateVersionAlert() {
      this.alertTitle = "更新版本";
      this.alertDescription = "確定要建立一個新的公版版本嗎？";
      this.btnText = "確認";
      this.$refs.createVersionAlertDialog.open();
    },
    async $_onCreateVersion() {
      this.$refs.createVersionAlertDialog.startLoading();
      await this.$_getModelVersionData(this.modelData);
      try {
        let newObject = JSON.parse(JSON.stringify(this.modelVersionData));
        //題目ＩＤ
        newObject[`${this.submodelName}s`] = newObject[
          `${this.submodelName}s`
        ].map((item) => {
          return item.id;
        });
        //題目版本ＩＤ
        let params = {};
        params[`${this.modelName}s`] = this.$route.params.id;
        const submodelRes = await this.$axios.get(`/${this.submodelName}/`, {
          params: params,
        });
        newObject[`${this.submodelVersionName}s`] = [];
        submodelRes.data.data.forEach((submodelItem) => {
          this.modelVersionData.chapters.forEach((chapterItem) => {
            chapterItem.sections.forEach((sectionItem) => {
              sectionItem.topics.forEach((topicItem) => {
                if (topicItem.id === submodelItem.id) {
                  newObject[`${this.submodelVersionName}s`].push(
                    submodelItem.last_version.id
                  );
                }
              });
            });
          });
        });
        newObject.version_status = 0;
        await this.$axios.post(
          `/${this.modelName}/${this.$route.params.id}/${this.versionModelName}`,
          newObject
        );
        await S_base.update({
          modelName: this.modelName,
          modelId: this.$route.params.id,
          payload: {status: 2},
        });
        this.$refs.createVersionAlertDialog.close();
        this.$refs.createVersionAlertDialog.stopLoading();
        this.isFetchData = !this.isFetchData;
      } catch (error) {
        alert(error);
      }
    },
    $_getModelData($event) {
      this.modelData = $event;
    },
  },
};
</script>